import { render, staticRenderFns } from "./Syslog.vue?vue&type=template&id=3db580c1&"
import script from "./Syslog.vue?vue&type=script&lang=ts&"
export * from "./Syslog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports